module.exports = __webpack_public_path__ + "media/images/home-soccer-mom-41a0525790a68ab7f9e4b30f8c9a3f4b.jpg";